import React from 'react';
import PropTypes from 'prop-types';
import accessMethodsHelper from 'helpers/accessMethodsHelper';
import AccessMethodsSettings from '../settings/AccessMethodsSettings';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import MenuItem from 'material-ui/MenuItem';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';
import RenderSelectInputField from 'components/form/InputFields/RenderSelectInputField';
import Row from 'components/list/Filters/layout/Row';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Section } from 'components/ui/table/elements';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

class AccessMethodEdit extends React.Component {
    submit = (values) => {
        const {
            handleSubmitForm,
            method,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        values = Object.assign({}, method, values);

        return handleSubmitForm(values);
    }

    render() {
        const {
            direction,
            handleSubmit,
            selected_method,
            submitting,
            translate,
        } = this.props;

        const directions = accessMethodsHelper.getDirectionIDs(selected_method);
        const settingsConfig = accessMethodsHelper.getSettings(selected_method);

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(this.submit.bind(this)) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderSelectInputField }
                                    label={ translate('resources.access_methods.fields.direction') }
                                    fullWidth={ false }
                                    disabled={ true }
                                    name='access_direction'
                                    startingValue={ direction }
                                    validate={ validations.required }
                                >
                                    {
                                        directions.map((direction) => {
                                            return (
                                                <MenuItem
                                                    key={ `method-${ direction }` }
                                                    primaryText={ translate(`resources.access_methods.list.directions.${ direction }`) }
                                                    value={ direction }
                                                />
                                            );
                                        })
                                    }
                                </Field>
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    label={ translate('resources.access_methods.fields.enabled') }
                                    type='checkbox'
                                    name='enabled'
                                    source='enabled'
                                />
                            </Item>
                        </Row>
                    </Section>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    label={ translate('resources.access_methods.fields.is_allowed_for_users') }
                                    type='checkbox'
                                    name='is_allowed_for_users'
                                    source='is_allowed_for_users'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <AccessMethodsSettings settings={ settingsConfig } />

                    <Section>
                        <ButtonWrapper>
                            <EnhancedRaisedButton
                                label={ translate('actions.submit') }
                                type='submit'
                                loading={ submitting }
                                disabled={ submitting }
                                primary
                            />
                        </ButtonWrapper>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

AccessMethodEdit.propTypes = {
    direction: PropTypes.number,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    method: PropTypes.shape({
        access_direction: PropTypes.number,
        access_method_id: PropTypes.number,
        enabled: PropTypes.bool,
        id: PropTypes.number,
        product_id: PropTypes.string,
        settings: PropTypes.shape({
            access_point_id: PropTypes.number,
            gate_id: PropTypes.string,
            depot_id: PropTypes.number,
            phone: PropTypes.string,
            product_id: PropTypes.string,
        }),
    }),
    selected_method: PropTypes.number,
    submitting: PropTypes.bool,
    translate: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    const selector = formValueSelector(props.form);

    return {
        direction: selector(state, 'access_direction'),
        selected_method: selector(state, 'access_method_id'),
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    translate,
    reduxForm(),
);

export default enhance(AccessMethodEdit);



// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/edit/AccessMethodEdit.js